import Vue from 'vue'
import appBuilder from './AppBuilder'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './assets/style.styl'
import filters from '@/commons/filters'
import credenciamentoFilters from '@/views/credenciamento/detalhe-credenciamento/filters'
import './commons/mixins'
import './plugins'
import VueTimers from 'vue-timers'

Vue.use(filters)
Vue.use(credenciamentoFilters)
Vue.use(VueTimers)

appBuilder.build()
